import React, { useState, useEffect, useContext} from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  TextField,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  TablePagination,
  Snackbar,
  Alert,
  useMediaQuery,
  Popover,
  Tooltip,
  Skeleton,
  CircularProgress
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  Search as SearchIcon,
  Add as AddIcon,
  Chat as ChatIcon,
  Delete as DeleteIcon,
  Edit as EditIcon
} from '@mui/icons-material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditButton from '../customcomponents/CustomEditButton';
import DeleteButton from '../customcomponents/CustomDeleteButton';
import SearchInput from '../customcomponents/CustomSearchInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd,faMinus } from '@fortawesome/free-solid-svg-icons';
import { SettingsContext } from '../App';

function AddressBookPage() {
  const navigate = useNavigate();
  const theme = useTheme();
  const [searchQuery, setSearchQuery] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [createContactDialog, setCreateContactDialog] = useState(false);
  const [editContactDialog, setEditContactDialog] = useState(false);
  const [editingContact, setEditingContact] = useState(null);
  const [editLoading, setEditLoading] = useState(false);
  const [editError, setEditError] = useState(null);
  const [newContact, setNewContact] = useState({
    name: '',
    phone: '',
    email: '',
    source: 'Whatsapp',
    tags: '',
    landMark:'',
    pincode:''
  });
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [createLoading, setCreateLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [createErrors, setCreateErrors] = useState({ name: '', phone: '', email: '', pincode: '' });
  const [editErrors, setEditErrors] = useState({ name: '', phone: '', email: '', pincode: '' });
  const [createPhoneError, setCreatePhoneError] = useState('');
  const [createPincodeError, setCreatePincodeError] = useState('');
  const [editPhoneError, setEditPhoneError] = useState('');
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [contactToDelete, setContactToDelete] = useState(null);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [addressData, setAddressData] = useState([]);
  const {settings,userRole}=useContext(SettingsContext);
  console.log(settings);
  // console.log(userRole);
  const canAccess = (keyName) => {
    const item = settings?.find(s => s.keyName === keyName);
    return item?.roles?.some(r => r.roleName === userRole);
  };

  const canAddressLine = canAccess("address_line");
  const canAddressSourceName=canAccess("address_source_name");


  const isSmallScreen = useMediaQuery('(max-width:800px)');

  const getSourceLabel = (ref) => {
    switch (ref) {
      case 1: return 'Whatsapp';
      case 2: return 'Website';
      case 3: return 'Phone';
      case 4: return 'Email';
      case 5: return 'App';
      default: return '-';
    }
  };

  const validateContact = (contact) => {
    let errors = { name: '', phone: '', email: '' };
    if (!contact.name.trim()) {
      errors.name = 'Name is required';
    }
    if (!/^\d{10}$/.test(contact.phone)) {
      errors.phone = 'Phone number must be 10 digits';
    }
    if (!contact.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/^\S+@\S+\.\S+$/.test(contact.email)) {
      errors.email = 'Invalid email format';
    }
    return errors;
  };

  // Move fetchContacts to top-level so it's available everywhere
  const fetchContacts = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await (await import('../api')).default.get('/patients');
      if (res.data && res.data.success && Array.isArray(res.data.data)) {
        setContacts(res.data.data.map((item) => ({
          id: item._id,
          name: item.TA_Patient_Name || '-',
          phone: item.TA_Patient_Mobile_Number || '-',
          email: item.TA_Patient_Email_Address || '-',
          createdOn: item.TA_Created_At ? new Date(item.TA_Created_At).toLocaleDateString() : '-',
          updatedOn: item.TA_Modified_At ? new Date(item.TA_Modified_At).toLocaleDateString() : '-',
          source: getSourceLabel(item.TA_Source_Type),
          tags: []
        })));
      } else {
        setContacts([]);
      }
    } catch (err) {
      setError('Failed to fetch contacts');
      setContacts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  // Filter contacts based on search query
  const filteredContacts = contacts.filter(contact =>
    contact.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    contact.phone.includes(searchQuery) ||
    contact.email.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Pagination
  const paginatedContacts = filteredContacts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleCreateContact = async () => {
    const errors = validateContact(newContact);
    setCreateErrors(errors);
    setCreatePhoneError(newContact.phone.length === 10 || newContact.phone.length === 0 ? '' : 'Phone number must be 10 digits');
    if (errors.name || errors.phone || errors.email || createPhoneError) return;
    setCreateLoading(true);
    try {
      const payload = {
        TA_Patient_Name: newContact.name,
        TA_Patient_Mobile_Number: newContact.phone,
        TA_Patient_Email_Address: newContact.email,
        TA_Patient_Age: 0, // You can add age field to the form if needed
        TA_Source_Type: newContact.source || 1, // You may want to map this from the source dropdown
        TA_Source_Status: 1, // Default to 1
        TA_Patient_AddresLine_Array : addressData || [],
        TA_Patient_LandMark : newContact.landMark || '',
        TA_Patient_PinCode:newContact.pincode || ''
      };
      const api = (await import('../api')).default;
      const res = await api.post('/patients', payload);
      if (res.data && res.data.success) {
        setSnackbar({ open: true, message: 'Patient created successfully', severity: 'success' });

        // Delay navigation by 1.2 seconds (1200 ms)
        setTimeout(() => {
          navigate('/interactions-new');
        }, 1200);

        setCreateContactDialog(false);
        setNewContact({ name: '', phone: '', email: '', source: 'Whatsapp', tags: '' });
        setCreateErrors({ name: '', phone: '', email: '' });
        fetchContacts();
      } else {
        setSnackbar({ open: true, message: 'Failed to create patient', severity: 'error' });
      }
    } catch (err) {
      setSnackbar({ open: true, message: 'Failed to create patient', severity: 'error' });
    } finally {
      setCreateLoading(false);
    }
  };

  const handleChat = (contact) => {
    console.log('Opening chat with:', contact);
    // Navigate to chat or open chat modal
  };

    const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleViewContact = (contact) => {
    setSelectedContact(contact);
    setViewDialogOpen(true);
  };

  const handleCloseViewDialog = () => {
    setViewDialogOpen(false);
    setSelectedContact(null);
  };


    const openDeleteDialog = (contact) => {
    setContactToDelete(contact);
    setDeleteDialogOpen(true);
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setContactToDelete(null);
  };
  
  const handleSearchClick = (event) => {
  setAnchorEl(event.currentTarget);
  };
  const handleClose=(e)=>{
    setAnchorEl(null);
    // setSearchQuery('');
  }

  const handleDeleteConfirm = async () => {
    if (!contactToDelete) return;

    setDeleteLoading(true);
    try {
      const api = (await import('../api')).default;
      const res = await api.delete(`/patients/${contactToDelete.id}`);
      if (res.data && res.data.success) {
        setSnackbar({ open: true, message: 'Patient deleted successfully', severity: 'success' });
        fetchContacts();
      } else {
        setSnackbar({ open: true, message: 'Failed to delete patient', severity: 'error' });
      }
    } catch (err) {
      setSnackbar({ open: true, message: 'Failed to delete patient', severity: 'error' });
    } finally {
      setDeleteLoading(false);
      handleDeleteCancel();
    }
  };

  const handleEdit = async (contact) => {
    setEditLoading(true);
    setEditError(null);
    try {
      const api = (await import('../api')).default;
      const res = await api.get(`/patients/${contact.id}`);
      if (res.data && res.data.success && res.data.data) {
        const patient = res.data.data;
        console.log(patient)
        setEditingContact(patient); // Store full patient object if needed
        setNewContact({
          name: patient.TA_Patient_Name || '',
          phone: patient.TA_Patient_Mobile_Number || '',
          email: patient.TA_Patient_Email_Address || '',
          source: patient.TA_Source_Type || 'Whatsapp',
          tags: '', // No tags in API,
          landMark: patient?.TA_Patient_LandMark,
          pincode:patient?.TA_Patient_PinCode,
        });
        setAddressData(patient?.TA_Patient_AddresLine_Array || [])
        setEditContactDialog(true);
      } else {
        setEditError('Failed to fetch patient details');
      }
    } catch (err) {
      setEditError('Failed to fetch patient details');
    } finally {
      setEditLoading(false);
    }
  };

  const handleUpdateContact = async () => {
    if (!editingContact || !editingContact._id) return;
    const errors = validateContact(newContact);
    setEditErrors(errors);
    setEditPhoneError(newContact.phone.length === 10 || newContact.phone.length === 0 ? '' : 'Phone number must be 10 digits');
    if (errors.name || errors.phone || errors.email || editPhoneError) return;
    setEditLoading(true);
    setEditError(null);
    try {
      const payload = {
        TA_Patient_Name: newContact.name,
        TA_Patient_Mobile_Number: newContact.phone,
        TA_Patient_Email_Address: newContact.email,
        TA_Patient_Age: 0, // You can add age field to the form if needed
        TA_Source_Type: 1, // You may want to map this from the source dropdown
        TA_Patient_Tag: [], // No tags in UI for now
        TA_Source_Type: typeof newContact.source === 'number' ? newContact.source : 1, // If you want to map source dropdown
        TA_Source_Status: 1, // Default to 1
        TA_Patient_AddresLine_Array : addressData || [],
        TA_Patient_LandMark : newContact.landMark || '',
        TA_Patient_PinCode: newContact.pincode || '',
      };
      const api = (await import('../api')).default;
      const res = await api.put(`/patients/${editingContact._id}`, payload);
      if (res.data && res.data.success) {
        setSnackbar({ open: true, message: 'Patient updated successfully', severity: 'success' });
        setEditContactDialog(false);
        setEditingContact(null);
        setNewContact({ name: '', phone: '', email: '', source: 'Whatsapp', tags: '' });
        setEditErrors({ name: '', phone: '', email: '' });
        fetchContacts();
      } else {
        setSnackbar({ open: true, message: 'Failed to update patient', severity: 'error' });
      }
    } catch (err) {
      setSnackbar({ open: true, message: 'Failed to update patient', severity: 'error' });
    } finally {
      setEditLoading(false);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbar({ ...snackbar, open: false });
  };


  // To close edit dialog and reset states
  const handleEditDialogClose =()=>[
    setEditContactDialog(false),
    setEditingContact(null),
    setNewContact({ name: '', phone: '', email: '', source: 'Whatsapp', tags: '' }),
    setEditErrors({ name: '', phone: '', email: '' }),
    setAddressData([])
  ]

  const handleCreateDialogClose =()=>[
    setCreateContactDialog(false),
    setNewContact({ name: '', phone: '', email: '', source: 'Whatsapp', tags: '' }),
    setCreateErrors({ name: '', phone: '', email: '' })
  ]

if (loading) {
    // On small screens: show animated skeletons
    if (isSmallScreen) {
      return (
        <>
        <Paper elevation={0} sx={{
        p: { xs: 2, sm: 3 }, mb: 2, borderRadius: 3, flexDirection: { xs: 'row', md: 'row' },
        background: theme.palette.mode == 'dark' ? '#32373a' :  'white', boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        display: 'flex', gap: 2, alignItems: 'center', position: 'sticky', justifyContent: 'space-between', zIndex: 1000, top: isSmallScreen?10:0,
      }}>
        {
          isSmallScreen ? (
            <Typography variant="h6" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>Address Book</Typography>
          ) : (
            <Typography variant="h4" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>Address Book</Typography>
          )
        }
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2,flexDirection: { xs: 'row', sm: 'row' } }}>

          {!isSmallScreen && (<SearchInput value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />)}

          {
            isSmallScreen ? (
               <>
                  <IconButton
                    onClick={handleSearchClick}
                    color='primary'
                  >
                    <SearchIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => setCreateContactDialog(true)}
                    color='primary'
                  >
                    <AddIcon />
                  </IconButton>
                  <Popover open={open} anchorEl={anchorEl} onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
                    transformOrigin={{  vertical: 'top',  horizontal: 'left', }}
                    PaperProps={{ sx: { p: 1, boxShadow: 'none', backgroundColor: 'rgba(255, 255, 255, 0.2)', borderRadius: 2, width: '60vw',  maxWidth: 400, }, }}
                  >
                    <SearchInput value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} autoFocus />  
                  </Popover> 
              </>
            ):(
              <Button
                variant="contained"
                onClick={() => setCreateContactDialog(true)}
                startIcon={<AddIcon />}
                sx={{ bgcolor: '#0088cc', color: '#fff', fontWeight: 700, borderRadius: 2, boxShadow: 1, 
                  fontSize: {xs: '0.75rem', sm: '1rem'}, px: 3, height: 40, textTransform: 'none',
                  '&:hover': {
                    bgcolor: '#0077b6',
                    boxShadow: 2
                  },
                }}
              >
                Add Contact
              </Button>

            )
          }
        </Box>
      </Paper>
      <Grid container spacing={1}>
        {[...Array(5)].map((_, index) => (
          <Grid item xs={12} key={index}>
            <Paper
              elevation={2}
              sx={{
                borderRadius: 3, p: 2, display: 'flex', flexDirection: 'column', gap: 1.5, position: 'relative', m:1, mt:0,
                boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
              }}
            >
              {/* SL No. */}
              <Skeleton
                variant="text"
                width={30}
                sx={{
                  position: 'absolute',
                  top: 12,
                  right: 18,
                  fontSize: 18,
                  fontWeight: 700,
                }}
              />

              {/* Name */}
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Skeleton variant="text" width={50} />
                <Skeleton variant="text" width={150} />
              </Box>

              {/* Number */}
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Skeleton variant="text" width={60} />
                <Skeleton variant="text" width="50%" />
              </Box>

              {/* Source */}
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Skeleton variant="text" width={50} />
                <Skeleton variant="text" width="40%" />
              </Box>

              {/* Buttons */}
              <Box display="flex" alignItems="center" gap={1} mt={1}>
                <Skeleton variant="rectangular" width={60} height={32} />
                <Skeleton variant="rectangular" width={80} height={32} />
                <Skeleton variant="rectangular" width={60} height={32} />
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
        </>
      );
    }

    // On larger screens
    return (
      <>
      <Paper elevation={0} sx={{
        p: { xs: 2, sm: 3 },
        mb: 2,
        borderRadius: 3,
        background: theme.palette.mode == 'dark' ? '#32373a' :  'white',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        display: 'flex',
        flexDirection: { xs: 'row', md: 'row' },
        alignItems: 'center',
        gap: 2,
        justifyContent: 'space-between',
        position: 'sticky',
        top: isSmallScreen?10:0,
        zIndex: 1000,
      }}>
        {
          isSmallScreen ? (
            <Typography variant="h6" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>Address Book</Typography>
          ) : (
            <Typography variant="h4" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>Address Book</Typography>
          )
        }
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2,flexDirection: { xs: 'row', sm: 'row' } }}>

          {!isSmallScreen && (<SearchInput value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />)}

          {
            isSmallScreen ? (
               <>
                  <IconButton
                    onClick={handleSearchClick}
                    color='primary'
                  >
                    <SearchIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => setCreateContactDialog(true)}
                    color='primary'
                  >
                    <AddIcon />
                  </IconButton>
                  <Popover open={open} anchorEl={anchorEl} onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
                    transformOrigin={{  vertical: 'top',  horizontal: 'left', }}
                    PaperProps={{ sx: { p: 1, boxShadow: 'none', backgroundColor: 'rgba(255, 255, 255, 0.2)', borderRadius: 2, width: '60vw',  maxWidth: 400, }, }}
                  >
                    <SearchInput value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} autoFocus />  
                  </Popover> 
              </>
            ):(
              <Button
                variant="contained"
                onClick={() => setCreateContactDialog(true)}
                startIcon={<AddIcon />}
                sx={{ bgcolor: '#0088cc', color: '#fff', fontWeight: 700, borderRadius: 2, boxShadow: 1, fontSize: {xs: '0.75rem', sm: '1rem'}, px: 3, height: 40, textTransform: 'none',
                  '&:hover': {
                    bgcolor: '#0077b6',
                    boxShadow: 2
                  },
                }}
              >
                Add Contact
              </Button>

            )
          }
        </Box>
      </Paper>
      <Paper
      elevation={1}
      sx={{
        borderRadius: 3,
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        p: 0,
        overflow: 'auto',
        background: 'background.paper',
        mb: 3,
      }}
    >
      <TableContainer sx={{ maxHeight: 540 }}>
        <Table stickyHeader>
          <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>SL No.</TableCell>
            <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Contact Name</TableCell>
            <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Phone Number</TableCell>
            <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Email ID</TableCell>
            <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Created On</TableCell>
            <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Source</TableCell>
            <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Tags</TableCell>
            <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Actions</TableCell>
          </TableRow>
        </TableHead>

          <TableBody>
            {Array.from(new Array(8)).map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                {Array.from(new Array(7)).map((_, colIndex) => (
                  <TableCell key={colIndex}>
                    <Skeleton variant="text" width="90%" height={20} />
                  </TableCell>
                ))}
                <TableCell>
                  <Box sx={{ display: 'flex', gap: 5 ,justifyContent:'center'}}>
                    <Skeleton variant="rectangular" width={40} height={30} sx={{ borderRadius: 1 }} />
                    <Skeleton variant="rectangular" width={40} height={30} sx={{ borderRadius: 1 }} />
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>

        </Table>
      </TableContainer>
      <Box sx={{ px: 2, py: 1, background: 'background.paper', borderRadius: '0 0 16px 16px' }}>
        <Skeleton variant="rectangular" width="100%" height={40} />
      </Box>
    </Paper>
    </>
    );
  }

  return (
    <Box sx={{ background: 'background.default' }}>
      <Paper elevation={0} sx={{
        p: { xs: 2, sm: 3 },
        mb: 2,
        borderRadius: 3,
        background: theme.palette.mode == 'dark' ? '#32373a' :  'white',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        display: 'flex',
        flexDirection: { xs: 'row', md: 'row' },
        alignItems: 'center',
        gap: 2,
        justifyContent: 'space-between',
        position: 'sticky',
        top: isSmallScreen?10:0,
        zIndex: 1000,
      }}>
        {
          isSmallScreen ? (
            <Typography variant="h6" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>Address Book</Typography>
          ) : (
            <Typography variant="h4" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>Address Book</Typography>
          )
        }
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2,flexDirection: { xs: 'row', sm: 'row' } }}>

          {!isSmallScreen && (<SearchInput value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />)}

          {
            isSmallScreen ? (
               <>
                  <IconButton
                    onClick={handleSearchClick}
                    color='primary'
                    // sx={{
                    //   bgcolor: theme.palette.primary.main,
                    //   color: theme.palette.primary.contrastText,
                    //   borderRadius: 2, boxShadow: 1,
                    //   '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2, },
                    //   height: 40, width: 40,
                    // }}
                  >
                    <SearchIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => setCreateContactDialog(true)}
                    color='primary'
                    // sx={{
                    //   bgcolor: theme.palette.primary.main,
                    //   color: theme.palette.primary.contrastText,
                    //   borderRadius: 2, boxShadow: 1, height: 40, width: 40,
                    //   '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2,}, 
                    // }}
                  >
                    <AddIcon />
                  </IconButton>
                  <Popover open={open} anchorEl={anchorEl} onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
                    transformOrigin={{  vertical: 'top',  horizontal: 'left', }}
                    PaperProps={{ sx: { p: 1, boxShadow: 'none', backgroundColor: 'rgba(255, 255, 255, 0.2)', borderRadius: 2, width: '60vw',  maxWidth: 400, }, }}
                  >
                    <SearchInput value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} autoFocus />  
                  </Popover> 
              </>
            ):(
              <Button
                variant="contained"
                onClick={() => setCreateContactDialog(true)}
                startIcon={<AddIcon />}
                sx={{ bgcolor: '#0088cc', color: '#fff', fontWeight: 700, borderRadius: 2, boxShadow: 1, fontSize: {xs: '0.75rem', sm: '1rem'}, px: 3, height: 40, textTransform: 'none',
                  '&:hover': {
                    bgcolor: '#0077b6',
                    boxShadow: 2
                  },
                }}
              >
                Add Contact
              </Button>

            )
          }
        </Box>
      </Paper>
      {/* <Box sx={{ mb: 2 }}> */}
        {/* <Box sx={{ borderBottom: 1, borderColor: '#e0e0e0', mb: 1 }} /> */}
      {/* </Box> */}
      {
        isSmallScreen ? (
          <>
          <Grid container spacing={1} >
            {filteredContacts.map((contact, index) => (
              <Grid item xs={12} key={contact.id}>
                <Paper
                  elevation={2}
                  sx={{
                    borderRadius: 3,
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.5,
                    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                    position: 'relative',
                    m:1,
                    mt:0
                  }}
                >
                  {/* SL No. in light gray with # at top */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 12,
                      right: 18,
                      color: '#b0b0b0',
                      fontWeight: 700,
                      fontSize: 18,
                      letterSpacing: 1,
                    }}
                  >
                    #{page * rowsPerPage + index + 1}
                  </Box>

                  <Box sx={{display:'flex',gap:1}} >
                    {/* Contact Name (label and value) */}
                    <Typography variant="subtitle2" sx={{ color: 'background.text', fontWeight: 500, fontSize:12 }}>
                      Name:
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'background.text', textTransform: 'capitalize', fontWeight: 700, fontSize:12 }}>
                      {contact.name}
                    </Typography>
                  </Box>

                  {/* Phone Number */}
                  <Box sx={{display:'flex',gap:1}} >
                    <Typography variant="body2" sx={{ color: 'background.text', fontWeight: 500, fontSize:12 }}>
                      Number:
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'background.text', fontWeight: 600, fontSize:12 }}>
                      {contact.phone}
                    </Typography>
                  </Box>

                  {/* Source */}
                  <Box sx={{display:'flex',gap:1}} >
                    <Typography variant="body2" sx={{ color: 'background.text', fontWeight: 500, fontSize:12 }}>
                      Source:
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'background.text', fontWeight: 600, fontSize:12 }}>
                      {contact.source}
                    </Typography>
                  </Box>

                  {/* Actions */}
                  <Box display="flex" alignItems="center" gap={1} mt={1}>
                    {/* <IconButton
                      color="primary"
                      onClick={() => {
                        // You can implement a view details dialog/modal here
                        alert(
                          `Contact Details:\nName: ${contact.name}\nPhone: ${contact.phone}\nEmail: ${contact.email}\nSource: ${contact.source}`
                        );
                      }}
                      sx={{
                        borderRadius: '50%',
                        boxShadow: '0 2px 8px 0 rgba(0,136,204,0.08)',
                        background: '#e3f2fd',
                        transition: 'box-shadow 0.25s, background 0.25s, transform 0.25s',
                        color: '#0088cc',
                        '&:hover': {
                          background: '#0088cc',
                          color: '#fff',
                          boxShadow: '0 4px 16px 0 rgba(0,136,204,0.18)',
                          transform: 'scale(1.18)'
                        }
                      }}
                      size="small"
                    >
                      <ChatIcon />
                    </IconButton> */}
                    <Button
                      size="small"
                      startIcon={<EditIcon />}
                      onClick={() => handleEdit(contact)}
                    >
                      Edit
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      startIcon={<DeleteIcon />}
                      onClick={() => openDeleteDialog(contact)}
                    >
                      Delete
                    </Button>
                    <Button
                      size="small"
                      startIcon={<VisibilityIcon />}
                      onClick={() => handleViewContact(contact)}
                    >
                      View
                    </Button>
                  </Box>
                </Paper>
              </Grid>
            ))}
            {/* Pagination for cards */}
            {/* <Grid item xs={12}>
              <Box sx={{ px: 0, py: 1, background: 'background.paper', borderRadius: '0 0 16px 16px' }}>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={filteredContacts.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage="Rows per page:"
                  labelDisplayedRows={({ from, to, count }) => `${from}–${to} of ${count}`}
                  sx={{ border: 0, background: 'transparent', p: 0, color: 'background.text' }}
                />
              </Box>
            </Grid> */}
          </Grid>
          </>
        ) : (
          <Paper elevation={1} sx={{ borderRadius: 3, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', p: 0, overflow: 'auto', background: 'background.paper', mb: 3, }}>
            <TableContainer sx={{ maxHeight: 540 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>SL No.</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Contact Name</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Phone Number</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Email ID</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Created On</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Source</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff' }}>Tags</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: '#0088cc', color: '#fff',textAlign:'center' }}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedContacts.map((contact, index) => (
                    <TableRow key={contact.id} sx={{ transition: 'background 0.2s', cursor: 'pointer', '&:hover': { backgroundColor: theme.palette.action.hover }  }} >
                      <TableCell sx={{color:'background.text'}}>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell sx={{color:'background.text',textTransform:"capitalize"}}>{contact.name}</TableCell>
                      <TableCell sx={{color:'background.text'}}>{contact.phone}</TableCell>
                      <TableCell sx={{color:'background.text'}}>{contact.email}</TableCell>
                      <TableCell sx={{color:'background.text'}}>{contact.createdOn}</TableCell>
                      <TableCell sx={{color:'background.text'}}>{contact.source}</TableCell>
                      <TableCell sx={{color:'background.text'}}>
                        {contact.tags.length > 0 ? contact.tags.join(',') : '-'}
                      </TableCell>
                      <TableCell>
                        <Box display="flex" justifyContent={'space-evenly'}>
                          {/* <IconButton
                            color="primary"
                            onClick={() => handleChat(contact)}
                            sx={{
                              borderRadius: '50%',
                              boxShadow: '0 2px 8px 0 rgba(0,136,204,0.08)',
                              background: '#e3f2fd',
                              transition: 'box-shadow 0.25s, background 0.25s, transform 0.25s',
                              color: '#0088cc',
                              '&:hover': {
                                background: '#0088cc',
                                color: '#fff',
                                boxShadow: '0 4px 16px 0 rgba(0,136,204,0.18)',
                                transform: 'scale(1.18)'
                              }
                            }}
                            size="small"
                          >
                            <ChatIcon />
                          </IconButton> */}
                          <EditButton onClick={() => handleEdit(contact)} />
                          <DeleteButton onClick={() => openDeleteDialog(contact)} />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ px: 2, py: 1, background: 'background.paper', borderRadius: '0 0 16px 16px' }}>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredContacts.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Rows per page:"
                labelDisplayedRows={({ from, to, count }) => `${from}–${to} of ${count}`}
                sx={{ border: 0, background: 'transparent', p: 0, color: 'background.text' }}
              />
            </Box>
          </Paper>
        )
      }
      {/* Create Contact Dialog */}
      <Dialog open={createContactDialog} onClose={handleCreateDialogClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 600,color:'background.text' }}>Create New Contact</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Contact Name"
                value={newContact.name}
                onChange={(e) => {
                  setNewContact({ ...newContact, name: e.target.value });
                  setCreateErrors({ ...createErrors, name: '' });
                }}
                error={!!createErrors.name}
                helperText={createErrors.name} 
                InputLabelProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}
                InputProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}  
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Phone Number"
                value={newContact.phone}
                onChange={(e) => {
                  // Only allow up to 10 digits
                  const val = e.target.value.replace(/[^\d]/g, '');
                  if (!/^\d{0,10}$/.test(val)) return;
                  setNewContact({ ...newContact, phone: val });
                  setCreateErrors({ ...createErrors, phone: '' });
                  setCreatePhoneError(val.length === 10 || val.length === 0 ? '' : 'Phone number must be 10 digits');
                }}
                error={!!createErrors.phone || !!createPhoneError}
                helperText={createErrors.phone || createPhoneError}
                InputLabelProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}
                InputProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}  
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email"
                type="email"
                value={newContact.email}
                onChange={(e) => {
                  setNewContact({ ...newContact, email: e.target.value });
                  setCreateErrors({ ...createErrors, email: '' });
                }}
                error={!!createErrors.email}
                helperText={createErrors.email}
                InputLabelProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}
                InputProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}  
              />
            </Grid>
            <Grid item xs={12}>
                <Box sx={{display:canAddressLine?'none':'flex',gap:1,justifyContent:'center',alignItems:'center'}}>
                  <TextField
                    margin="dense"
                    label="Address Line"
                    type="Address"
                    fullWidth
                    value={addressData ? addressData[0]?.value : ""}
                    onChange={e => {
                      const newData = [...addressData];
                      newData[0] = { id: 0, value: e.target.value };
                      setAddressData(newData);
                    }}
                    
                  />
                  <Tooltip title='Add another address line'>
                    <Box
                      sx={{
                        width: '35px',
                        height: "30px",
                        background: '#0088cc',
                        borderRadius: '10px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        transition: 'all ease-in-out 0.5s',
                        '&:hover': { background: "#004d74", transform: 'scale(1.1)' }
                      }}
                      onClick={() => setAddressData([...(addressData || []), { id: (addressData?.length || 0), value: "" }])}
                    >
                      <FontAwesomeIcon icon={faAdd} style={{ color: '#fff' }} />
                    </Box>
                  </Tooltip>
                </Box>
              </Grid>
                      
              {addressData.length > 1 && addressData.slice(1).map((addr, ind) => (
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    <TextField
                      key={addr.id}
                      margin="dense"
                      label={`Address Line ${ind + 2}`}
                      type="Address"
                      fullWidth
                      value={addr.value}
                      onChange={e => {
                        const newData = [...addressData];
                        newData[ind + 1] = { ...newData[ind + 1], value: e.target.value };
                        setAddressData(newData);
                      }}
                      
                    />
                    <Tooltip title="Remove this address line">
                      <Box
                        sx={{
                          width: '35px', height: "30px", borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center',
                          background: '#cc0000a6', cursor: 'pointer', transition: 'all ease-in-out 0.5s',
                          '&:hover': { background: "#af0303bb", transform: 'scale(1.1)' }
                        }}
                        onClick={() => {
                          const newData = [...addressData];
                          newData.splice(ind + 1, 1); // remove this line
                          setAddressData(newData);
                        }}
                      >
                        <FontAwesomeIcon icon={faMinus} style={{ color: '#fff' }} />
                      </Box>
                    </Tooltip>
                  </Box>
                </Grid>
              ))}

              <Grid item xs={12} sx={{display:canAddressLine?'none':'flex'}}>
                <TextField
                  margin="dense"
                  label="Pincode"
                  type="pincode"
                  fullWidth
                  value={newContact.pincode}
                  // onChange={e => setNewContact({ ...newContact, pincode: e.target.value })}
                  onChange={(e) => {
                  // Only allow up to 10 digits
                  const val = e.target.value.replace(/[^\d]/g, '');
                  if (!/^\d{0,6}$/.test(val)) return;
                  setNewContact({ ...newContact, pincode: val });
                  setCreateErrors({ ...createErrors, pincode: '' });
                  setCreatePincodeError(val.length === 6 || val.length === 0 ? '' : 'Pincode must be 6 digits');
                }}
                error={!!createErrors.pincode || !!createPincodeError}
                helperText={createErrors.pincode || createPincodeError}
                />
              </Grid>
              <Grid item xs={12} sx={{display:canAddressLine?'none':'flex'}}>
                <TextField
                  margin="dense"
                  label="Land Mark"
                  type="landmark"
                  fullWidth
                  value={newContact.landMark}
                  onChange={e => setNewContact({ ...newContact, landMark: e.target.value })}
                  
                />
              </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel sx={{color:'background.text'}}>Source</InputLabel>
                <Select
                  value={newContact.source}
                  onChange={(e) => setNewContact({ ...newContact, source: e.target.value })}
                  label="Source"
                  sx={{color:'background.text'}}
                >
                  <MenuItem value="1" sx={{color:'background.text'}}>Whatsapp</MenuItem>
                  <MenuItem value="2" sx={{color:'background.text'}}>Call</MenuItem>
                  <MenuItem value="3" sx={{color:'background.text'}}>Website</MenuItem>
                  <MenuItem value="4" sx={{color:'background.text'}}>Email</MenuItem>
                  <MenuItem value="5" sx={{display:canAddressSourceName?'none':'flex',color:'background.text'}}>App</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Tags (comma separated)"
                value={newContact.tags}
                onChange={(e) => setNewContact({ ...newContact, tags: e.target.value })}
                placeholder="e.g., customer, vip, prospect"
                InputLabelProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}
                InputProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}  
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {handleCreateDialogClose(); setAddressData([]);}}
            sx={{
              color: theme.palette.primary.main,
              fontWeight: 600,
              '&:hover': {
                backgroundColor: 'rgba(25, 118, 210, 0.04)'
              }
            }}
            disabled={createLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleCreateContact}
            variant="contained"
            sx={{
              bgcolor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              fontWeight: 600,
              '&:hover': {
                bgcolor: theme.palette.primary.dark,
                boxShadow: 2
              }
            }}
            disabled={createLoading}
          >
            {createLoading ? 'Creating...' : 'Create Contact'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Contact Dialog */}
      <Dialog open={editContactDialog} onClose={handleEditDialogClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 600,color:'background.text' }}>Edit Contact</DialogTitle>
        <DialogContent>
          {editLoading ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight={120}>
              <Typography variant="body1" sx={{color:'background.text'}}>Loading...</Typography>
            </Box>
          ) : editError ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight={120}>
              <Typography variant="body1" color="error">{editError}</Typography>
            </Box>
          ) : (
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Contact Name"
                  value={newContact.name}
                  onChange={(e) => {
                    setNewContact({ ...newContact, name: e.target.value });
                    setEditErrors({ ...editErrors, name: '' });
                  }}
                  error={!!editErrors.name}
                  helperText={editErrors.name}
                  InputLabelProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}
                InputProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}  
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Phone Number"
                  value={newContact.phone}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^\d]/g, '');
                    if (!/^\d{0,10}$/.test(val)) return;
                    setNewContact({ ...newContact, phone: val });
                    setEditErrors({ ...editErrors, phone: '' });
                    setEditPhoneError(val.length === 10 || val.length === 0 ? '' : 'Phone number must be 10 digits');
                  }}
                  error={!!editErrors.phone || !!editPhoneError}
                  helperText={editErrors.phone || editPhoneError}
                  InputLabelProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}
                InputProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}  
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Email"
                  type="email"
                  value={newContact.email}
                  onChange={(e) => {
                    setNewContact({ ...newContact, email: e.target.value });
                    setEditErrors({ ...editErrors, email: '' });
                  }}
                  error={!!editErrors.email}
                  helperText={editErrors.email}
                  InputLabelProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}
                InputProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}  
                />
              </Grid>
              <Grid item xs={12}>
                <Box sx={{display:canAddressLine?'none':'flex',gap:1,justifyContent:'center',alignItems:'center'}}>
                  <TextField
                    margin="dense"
                    label="Address Line"
                    type="Address"
                    fullWidth
                    value={addressData ? addressData[0]?.value : ""}
                    onChange={e => {
                      const newData = [...addressData];
                      newData[0] = { id: 0, value: e.target.value };
                      setAddressData(newData);
                    }}
                    
                  />
                  <Tooltip title='Add another address line'>
                    <Box
                      sx={{
                        width: '35px',
                        height: "30px",
                        background: '#0088cc',
                        borderRadius: '10px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        transition: 'all ease-in-out 0.5s',
                        '&:hover': { background: "#004d74", transform: 'scale(1.1)' }
                      }}
                      onClick={() => setAddressData([...(addressData || []), { id: (addressData?.length || 0), value: "" }])}
                    >
                      <FontAwesomeIcon icon={faAdd} style={{ color: '#fff' }} />
                    </Box>
                  </Tooltip>
                </Box>
              </Grid>
                      
              {addressData.length > 1 && addressData.slice(1).map((addr, ind) => (
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    <TextField
                      key={addr.id}
                      margin="dense"
                      label={`Address Line ${ind + 2}`}
                      type="Address"
                      fullWidth
                      value={addr.value}
                      onChange={e => {
                        const newData = [...addressData];
                        newData[ind + 1] = { ...newData[ind + 1], value: e.target.value };
                        setAddressData(newData);
                      }}
                      
                    />
                    <Tooltip title="Remove this address line">
                      <Box
                        sx={{
                          width: '35px', height: "30px", borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center',
                          background: '#cc0000a6', cursor: 'pointer', transition: 'all ease-in-out 0.5s',
                          '&:hover': { background: "#af0303bb", transform: 'scale(1.1)' }
                        }}
                        onClick={() => {
                          const newData = [...addressData];
                          newData.splice(ind + 1, 1); // remove this line
                          setAddressData(newData);
                        }}
                      >
                        <FontAwesomeIcon icon={faMinus} style={{ color: '#fff' }} />
                      </Box>
                    </Tooltip>
                  </Box>
                </Grid>
              ))}

              <Grid item xs={12} sx={{display:canAddressLine?'none':'flex'}}>
                <TextField
                  margin="dense"
                  label="Pincode"
                  type="pincode"
                  fullWidth
                  value={newContact.pincode}
                  onChange={e => setNewContact({ ...newContact, pincode: e.target.value })}
                  
                />
              </Grid>
              <Grid item xs={12} sx={{display:canAddressLine?'none':'flex'}}>
                <TextField
                  margin="dense"
                  label="Land Mark"
                  type="landmark"
                  fullWidth
                  value={newContact.landMark}
                  onChange={e => setNewContact({ ...newContact, landMark: e.target.value })}
                  
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel sx={{color:'background.text'}}>Source</InputLabel>
                  <Select
                    value={newContact.source}
                    onChange={(e) => setNewContact({ ...newContact, source: e.target.value })}
                    label="Source"
                    sx={{color:'background.text'}}
                  >
                    <MenuItem value="1" sx={{color:'background.text'}}>Whatsapp</MenuItem>
                    <MenuItem value="2" sx={{color:'background.text'}}>Call</MenuItem>
                    <MenuItem value="3" sx={{color:'background.text'}}>Website</MenuItem>
                    <MenuItem value="4" sx={{color:'background.text'}}>Email</MenuItem>
                    <MenuItem value="5" sx={{display:canAddressSourceName?'none':'flex',color:'background.text'}}>App</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Tags (comma separated)"
                  value={newContact.tags}
                  onChange={(e) => setNewContact({ ...newContact, tags: e.target.value })}
                  placeholder="e.g., customer, vip, prospect"
                  InputLabelProps={{
                    style: {
                      color: theme.palette.background.text,
                    },
                  }}
                  InputProps={{
                    style: {
                      color: theme.palette.background.text,
                    },
                  }}  
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleEditDialogClose()}
            sx={{
              color: theme.palette.primary.main,
              fontWeight: 600,
              '&:hover': {
                backgroundColor: 'rgba(25, 118, 210, 0.04)'
              }
            }}
            disabled={editLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUpdateContact}
            variant="contained"
            sx={{
              bgcolor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              fontWeight: 600,
              '&:hover': {
                bgcolor: theme.palette.primary.dark,
                boxShadow: 2
              }
            }}
            disabled={editLoading}
          >
            Update Contact
          </Button>
        </DialogActions>
      </Dialog>
      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      {/* <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} elevation={6} variant="filled" sx={{ fontSize: 16, fontWeight: 600, borderRadius: 2 }}>
          {snackbar.message}
        </Alert>
      </Snackbar> */}

      {/* View Contact Dialog */}
      <Dialog open={viewDialogOpen} onClose={handleCloseViewDialog} fullWidth maxWidth="xs" >
        <DialogTitle>
          Contact Details
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1"><strong>Name:</strong> {selectedContact?.name}</Typography>
          <Typography variant="body1"><strong>Phone:</strong> {selectedContact?.phone}</Typography>
          <Typography variant="body1"><strong>Email:</strong> {selectedContact?.email}</Typography>
          <Typography variant="body1"><strong>Source:</strong> {selectedContact?.source}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseViewDialog}>Close</Button>
        </DialogActions>
      </Dialog>


      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 600, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary }}>
          Delete Contact
        </DialogTitle>
        <DialogContent sx={{ bgcolor: 'transparent' }}>
          <Typography sx={{ color: 'background.text' }}>
            Are you sure you want to delete <b>{contactToDelete?.name}</b>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} sx={{ fontWeight: 600 }} disabled={deleteLoading}>
            Cancel
          </Button>
          <Button
            onClick={handleDeleteConfirm}
            color="error"
            variant="contained"
            sx={{ fontWeight: 600 }}
            disabled={deleteLoading}
          >
            {deleteLoading ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
}

export default AddressBookPage; 